<template>
    <div>
        <!-- This page pretty much purely sends you off to Auth0 -->
        <b-loading :is-full-page="true" :active="true"></b-loading>
    </div>
</template>

<script>
// import Vue from "vue";

export default {
    name: "login",
    created() {
        if ( ! this.$auth.loading) {
            if ( ! this.$auth.isAuthenticated) {
                this.$auth.loginWithRedirect();
            }
            else {
                this.unexpectedUserDebugMessage();
            }
        }
        else {
            this.$auth.$watch('loading', loading => {
                if (loading === false) {
                    if ( ! this.$auth.isAuthenticated) {
                        this.$auth.loginWithRedirect();
                    }
                    else {
                        this.unexpectedUserDebugMessage();
                    }
                }
            });
        }
    },
    methods: {
        unexpectedUserDebugMessage() {
            // Configure global route guard to redirect
            // logged-in users to suitable start page.
            this.$buefy.toast.open({
                type: 'is-danger',
                message: 'Error: Not expecting already logged in user.'
            })
        }
    }
};
</script>
